export default {
  coordinateBoundaries: {
    minLng: -180,
    maxLng: 180,
    minLat: -64, // exclude Antarctica
    maxLat: 83 // exclude North Pole
  },
  zoomLevels: [3, 5, 7, 12, 17]
}
